import {APIService} from '@/APIService';

const apiService = new APIService();

export default{
    namespaced: true,
    state: {
        order_id: null,
        listProducts: [],
        customer: null,
        discount: 0,
        subtotal: 0,
        amount_igv: 0,
        total: 0,
        total_order: 0,
        total_return: 0,
        total_payment: 0,
        total_pending: 0,
        type_order: null,
        deliver_order: false
    },
    mutations: {
        setOrderId(state, order_id){
            state.order_id = order_id
        },
        setListProducts(state, listProducts) {
            state.listProducts = listProducts
        },
        setDiscount(state, discount) {
            state.discount = discount
        },
        setSubtotal(state, subtotal) {
            state.subtotal = subtotal
        },
        setAmountIgv(state, amount_igv) {
            state.amount_igv = amount_igv
        },
        setTotal(state, total) {
            state.total = total
        },
        setCustomer(state, customer) {
            state.customer = customer
        },
        setTotalReturn(state, total_return) {
            state.total_return = total_return
        },
        set_total_payment (state, value) {
            state.total_payment = value;
        },
        set_total_pending (state, value) {
            state.total_pending = value;
        },
        set_type_order (state, value) {
            state.type_order = value;
        },
        set_total_order (state, value) {
            state.total_order = value;
        },
        set_deliver_order (state, value) {
            state.deliver_order = value;
        }
    },
    actions: {
        setTotalPayment ({commit}, value) {
            commit('set_total_payment', value);
        },
        setTotalPending ({commit}, value) {
            commit('set_total_pending', value);
        },
        setTypeOrder({commit}, value) {
            commit('set_type_order', value);
        },
        setTotalOrder ({commit}, value) {
            commit('set_total_order', value);
        },
        setDeliverOrder ({commit}, value) {
            commit('set_deliver_order', value);
        },
        runSetOrderIdPay({commit}, order_id) {
            commit('setOrderId', order_id)
        },
        runSetSubtotal({commit}, subtotal) {
            commit('setSubtotal', subtotal)
        },
        runSetTotal({commit}, total) {
            commit('setTotal', total)
        },
        runSetAmountIgv({commit}, amount_igv) {
            commit('setAmountIgv', amount_igv)
        },
        runSetListProducts({commit}, listProducts) {
            commit('setListProducts', listProducts)
            let discount = 0
            let total_return = 0
            listProducts.forEach(element => {
                discount = discount + parseFloat(element.discount_value);          
            });
            commit('setDiscount', discount)
            commit('setTotalReturn', total_return)
        },
        runSetCustomer({commit}, customer) {
            commit('setCustomer', null)
            commit('setCustomer', customer)
        },
        getCustomers({commit}){
            return apiService.getCustomersDropdown()
                .then(({data}) => {
                    commit('setCustomers', data)
                })
        },
    }
}